var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.breadcrumbs.length > 1)?_c('nav',_vm._l((_vm.breadcrumbs),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.click(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('ChevronIcon')],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }